import React from "react";
import { InfoBoxWrap } from "./styles";
import { cleanRackingName } from "../../../Redux";
import { DollarCircleOutlined } from "@ant-design/icons";

// svg images
// const Briefcase = () => (
//   <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="https://www.w3.org/2000/svg">
//     <path
//       fillRule="evenodd"
//       clipRule="evenodd"
//       d="M8.66669 0C7.56212 0 6.66669 0.89543 6.66669 2V3.31656H2C0.895431 3.31656 0 4.21199 0 5.31656V11.5715V17.8265C0 18.9311 0.895434 19.8265 2 19.8265H18.5185C19.6231 19.8265 20.5185 18.9311 20.5185 17.8265V11.5715V5.31656C20.5185 4.21199 19.6231 3.31656 18.5185 3.31656H13.8519V2C13.8519 0.89543 12.9564 0 11.8519 0H8.66669ZM11.8519 3.31656V2H8.66669V3.31656H11.8519ZM2 5.31656L18.5185 5.31656L18.5185 10.5715H2V5.31656ZM12.3312 12.5715H18.5185V17.8265H2V12.5715H8.18728C8.36149 13.4003 9.09672 14.0225 9.97729 14.0225H10.5412C11.4218 14.0225 12.157 13.4003 12.3312 12.5715Z"
//       fill="var(--primary-brand-color)"
//     />
//   </svg>
// );
//
// const Calander = () => (
//   <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="https://www.w3.org/2000/svg">
//     <path
//       fillRule="evenodd"
//       clipRule="evenodd"
//       d="M6 4H4V3H2V6H18V3H16V4H14V3H6V4ZM18 8H2V18H18V8ZM14 1H6V0H4V1H2C0.89543 1 0 1.89543 0 3V18C0 19.1046 0.89543 20 2 20H18C19.1046 20 20 19.1046 20 18V3C20 1.89543 19.1046 1 18 1H16V0H14V1ZM5 12V10H7V12H5ZM9 12H11V10H9V12ZM13 12V10H15V12H13ZM5 14V16H7V14H5ZM11 16H9V14H11V16Z"
//       fill="var(--primary-brand-color)"
//     />
//   </svg>
// );
//
// const Location = () => (
//   <svg width="17" height="20" viewBox="0 0 17 20" fill="none" xmlns="https://www.w3.org/2000/svg">
//     <path
//       fillRule="evenodd"
//       clipRule="evenodd"
//       d="M8.06178 20L8.65094 19.4856C13.6053 15.1595 16.1236 11.3821 16.1236 8.06178C16.1236 3.35967 12.4536 0 8.06178 0C3.66995 0 0 3.35967 0 8.06178C0 11.3821 2.51824 15.1595 7.47262 19.4856L8.06178 20ZM8.06178 17.6136C3.85766 13.8247 1.79151 10.614 1.79151 8.06178C1.79151 4.38615 4.62577 1.79151 8.06178 1.79151C11.4978 1.79151 14.3321 4.38615 14.3321 8.06178C14.3321 10.614 12.2659 13.8247 8.06178 17.6136ZM8.06178 11.6448C10.0406 11.6448 11.6448 10.0406 11.6448 8.06178C11.6448 6.08294 10.0406 4.47877 8.06178 4.47877C6.08294 4.47877 4.47877 6.08294 4.47877 8.06178C4.47877 10.0406 6.08294 11.6448 8.06178 11.6448ZM8.06178 10.2116C6.87447 10.2116 5.91197 9.24909 5.91197 8.06178C5.91197 6.87447 6.87447 5.91197 8.06178 5.91197C9.24909 5.91197 10.2116 6.87447 10.2116 8.06178C10.2116 9.24909 9.24909 10.2116 8.06178 10.2116Z"
//       fill="var(--primary-brand-color)"
//     />
//   </svg>
// );

const Bulb = () => (
  <svg width="14" height="20" viewBox="0 0 14 20" fill="none" xmlns="https://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 13.915V16C11 18.2091 9.20914 20 7 20C4.79086 20 3 18.2091 3 16V13.915C3 13.7197 2.93083 13.5067 2.76746 13.2262C2.6625 13.046 2.52518 12.848 2.318 12.5739L2.24831 12.483C2.10998 12.3027 1.80784 11.9089 1.6963 11.7583C0.566442 10.2322 0 8.86987 0 7C0 3.13401 3.13401 0 7 0C10.866 0 14 3.13401 14 7C14 8.91076 13.4258 10.3248 12.3056 11.848C12.1868 12.0094 11.8873 12.3987 11.7099 12.6292L11.7099 12.6292C11.6405 12.7195 11.5898 12.7854 11.5759 12.8039C11.3495 13.105 11.2089 13.3185 11.1175 13.5039C11.0347 13.6717 11 13.8013 11 13.915ZM9.04369 13.4393C9.0947 13.1627 9.18955 12.8913 9.32384 12.6191C9.4817 12.2991 9.68243 11.9943 9.97716 11.6022C9.99736 11.5753 10.0624 11.4908 10.1463 11.3816L10.1468 11.3809C10.3269 11.1468 10.594 10.7996 10.6944 10.663C11.583 9.45479 12 8.42791 12 7C12 4.23858 9.76142 2 7 2C4.23858 2 2 4.23858 2 7C2 8.37855 2.40666 9.35662 3.3037 10.5682C3.39996 10.6982 3.67174 11.0526 3.81868 11.2442L3.81889 11.2444L3.91348 11.3679C4.16474 11.7003 4.3425 11.9566 4.49567 12.2196C4.73422 12.6291 4.89259 13.0283 4.9612 13.4423C5.58435 13.8163 6.25799 14 7 14C7.74395 14 8.41917 13.8153 9.04369 13.4393ZM9 16V15.6624C8.36753 15.8869 7.69934 16 7 16C6.30066 16 5.63247 15.8869 5 15.6624V16C5 17.1046 5.89543 18 7 18C8.10457 18 9 17.1046 9 16Z"
      fill="var(--primary-brand-color)"
    />
  </svg>
);

const Pound = () => (
  <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="https://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 0H6L5.4 6H1.2L1 8H5.2L4.8 12H0.2L0 14H4.6L4 20H6L6.6 14H10.6L10 20H12L12.6 14H16.8L17 12H12.8L13.2 8H17.8L18 6H13.4L14 0H12L11.4 6H7.4L8 0ZM7.2 8L6.8 12H10.8L11.2 8H7.2Z"
      fill="var(--primary-brand-color)"
    />
  </svg>
);

const Sunshine = () => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="https://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.20654 21.1905L4.52209 16.6684L0 14.9839L2.00653 10.5952L0 6.20654L4.52209 4.52209L6.20654 0L10.5952 2.00651L14.9839 0L16.6684 4.52209L21.1905 6.20654L19.184 10.5952L21.1905 14.9839L16.6684 16.6684L14.9839 21.1905L10.5952 19.184L6.20654 21.1905ZM10.5952 16.9848L13.8602 18.4776L15.1133 15.1134L18.4776 13.8602L16.9849 10.5952L18.4776 7.33026L15.1133 6.0771L13.8602 2.71288L10.5952 4.20563L7.33026 2.71288L6.07709 6.0771L2.71289 7.33026L4.20563 10.5952L2.71289 13.8602L6.07709 15.1134L7.33026 18.4776L10.5952 16.9848ZM10.5 15C12.9853 15 15 12.9853 15 10.5C15 8.01472 12.9853 6 10.5 6C8.01471 6 6 8.01472 6 10.5C6 12.9853 8.01471 15 10.5 15ZM10.5 13.2C9.00885 13.2 7.79999 11.9912 7.79999 10.5C7.79999 9.00883 9.00885 7.8 10.5 7.8C11.9911 7.8 13.2 9.00883 13.2 10.5C13.2 11.9912 11.9911 13.2 10.5 13.2Z"
      fill="var(--primary-brand-color)"
    />
  </svg>
);

const LightningBolt = () => (
  <svg width="17" height="22" viewBox="0 0 17 22" fill="none" xmlns="https://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 13.8508H5.08063V21.7016L16.1612 7.85078H11.0806V0L0 13.8508ZM7.08062 11.8508H4.16125L9.08062 5.70156V9.85078H12L7.08062 16V11.8508Z"
      fill="var(--primary-brand-color)"
    />
  </svg>
);

const Beam = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="https://www.w3.org/2000/svg">
    <path
      d="M20 2.33332V0.33332C20 0.329062 19.9977 0.325508 19.9976 0.321289C19.997 0.28168 19.9891 0.242539 19.9746 0.205703L19.9741 0.204844C19.9729 0.201797 19.9705 0.19957 19.9691 0.196602C19.9543 0.164102 19.9341 0.134258 19.9096 0.108242C19.9015 0.100156 19.893 0.0925 19.8842 0.0853125C19.8632 0.0668359 19.8398 0.0510937 19.8148 0.0385547C19.8045 0.0329687 19.7939 0.0279297 19.783 0.0235156C19.746 0.00867188 19.7066 0.000703125 19.6666 0H9C8.9116 3.90625e-05 8.82684 0.0351562 8.76434 0.0976562L0.0977734 8.76422L0.0972656 8.76484C0.0704688 8.79258 0.04875 8.8248 0.0330859 8.86004C0.0177734 8.89824 0.00804688 8.93844 0.00414062 8.97941C0.00367187 8.9866 0 8.9927 0 9V11C0 11.1841 0.149219 11.3333 0.33332 11.3333H2.83332C3.66137 11.3342 4.33242 12.0053 4.33332 12.8333V13.1953L0.0977734 17.4309C0.035625 17.4937 0.000546875 17.5783 0 17.6667V19.6667C0 19.8508 0.149219 20 0.33332 20H11C11.045 20 11.0894 19.9909 11.1307 19.9731C11.1352 19.9712 11.1384 19.9671 11.1429 19.965C11.1782 19.9486 11.2105 19.9262 11.2382 19.8987L11.2414 19.8965L17.9023 12.9023L19.9023 10.9023C19.9648 10.8398 20 10.7551 20 10.6667V8.66668C20 8.66242 19.9977 8.65887 19.9976 8.65465C19.997 8.61504 19.9891 8.5759 19.9746 8.53906L19.9741 8.5382C19.9729 8.53516 19.9705 8.53293 19.9691 8.52996C19.9364 8.4618 19.8822 8.40629 19.8148 8.37191C19.8045 8.36629 19.7939 8.36129 19.7831 8.35684C19.746 8.34199 19.7066 8.33402 19.6667 8.33332H17.1667C17.1383 8.3352 17.1103 8.34086 17.0834 8.35016C17.0564 8.3409 17.0284 8.33523 17 8.33332C16.2225 8.33094 15.5762 7.73363 15.5127 6.95863L19.9021 2.56922C19.9644 2.50645 19.9995 2.42176 20 2.33332ZM9.13801 0.66668H18.862L10.862 8.66668H1.13801L9.13801 0.66668ZM4.33332 14.138V15.8333C4.33242 16.6614 3.66137 17.3324 2.83332 17.3333H1.13801L4.33332 14.138ZM10.6667 19.3333H0.66668V18H2.83336C4.02941 17.9986 4.99863 17.0294 5.00004 15.8333V12.8333C4.99867 11.6373 4.02941 10.668 2.83336 10.6666H0.66668V9.33332H10.6667V10.6666H8.5C7.30395 10.668 6.33473 11.6373 6.33332 12.8333V15.8333C6.33469 17.0294 7.30395 17.9986 8.5 18H10.6667V19.3333V19.3333ZM19.3333 10.5286L17.4251 12.4368L11.3333 18.8332V17.7999L17.9023 10.9023L19.3334 9.47137V10.5286H19.3333ZM17 9C17.0284 8.99812 17.0564 8.99246 17.0833 8.98316C17.1102 8.99242 17.1382 8.99809 17.1666 9H18.862L17.4251 10.4368L10.8571 17.3333H8.5C7.67195 17.3324 7.0009 16.6614 7 15.8333V12.8333C7.0009 12.0053 7.67195 11.3342 8.5 11.3333H11C11.0884 11.333 11.1731 11.2979 11.2358 11.2355L14.948 7.52336C15.2448 8.40453 16.0702 8.99848 17 9ZM19.3333 2.19531L14.9311 6.59754L14.9309 6.59773L11.3333 10.1953V9.13801L19.3333 1.13801V2.19531Z"
      fill="var(--primary-brand-color)"
    />
    <path
      d="M8.46118 15.6735C8.3361 15.6216 8.19203 15.6504 8.09668 15.7466C8.03578 15.8105 8.00129 15.895 8 15.9833C8 16.1674 8.14926 16.3166 8.33332 16.3166C8.51743 16.3166 8.66665 16.1674 8.66665 15.9833C8.66747 15.8478 8.58625 15.7254 8.46118 15.6735Z"
      fill="var(--primary-brand-color)"
    />
    <path
      d="M9.74535 14.2633C9.62961 14.2352 9.50766 14.2709 9.42543 14.3571L9.09211 14.7064C8.96555 14.8397 8.97074 15.0503 9.10375 15.1771C9.23676 15.304 9.44735 15.2993 9.57453 15.1667L9.90785 14.8174C9.99008 14.7312 10.0201 14.6077 9.98657 14.4934C9.95305 14.3791 9.8611 14.2914 9.74535 14.2633Z"
      fill="var(--primary-brand-color)"
    />
    <path
      d="M10.7588 12.9603L10.4255 13.3096C10.2984 13.4428 10.3033 13.6538 10.4366 13.7809C10.5698 13.908 10.7808 13.9031 10.9079 13.7699L11.2412 13.4206C11.3684 13.2874 11.3634 13.0763 11.2302 12.9492C11.097 12.8221 10.8859 12.8271 10.7588 12.9603Z"
      fill="var(--primary-brand-color)"
    />
    <path
      d="M12.0921 11.5635L11.7588 11.9128C11.6667 12.0093 11.641 12.1514 11.6935 12.2741C11.746 12.3968 11.8665 12.4763 12 12.4763C12.0911 12.4764 12.1783 12.4391 12.2412 12.373L12.5745 12.0238C12.7016 11.8905 12.6967 11.6795 12.5635 11.5524C12.4302 11.4253 12.2192 11.4303 12.0921 11.5635Z"
      fill="var(--primary-brand-color)"
    />
    <path
      d="M13.7457 10.0722C13.6297 10.0441 13.5076 10.0801 13.4254 10.1667L13.0921 10.516C13 10.6125 12.9743 10.7546 13.0268 10.8773C13.0793 11 13.1999 11.0795 13.3333 11.0795C13.4244 11.0796 13.5117 11.0423 13.5745 10.9763L13.9078 10.6269C13.9904 10.5408 14.0207 10.4171 13.9872 10.3026C13.9537 10.1882 13.8616 10.1003 13.7457 10.0722Z"
      fill="var(--primary-brand-color)"
    />
    <path
      d="M14.5388 9.04015C14.4137 9.09207 14.3325 9.21453 14.3333 9.34996C14.3317 9.43781 14.3667 9.52234 14.43 9.58335C14.4923 9.64699 14.5776 9.68296 14.6667 9.68328C14.7557 9.68296 14.841 9.64695 14.9033 9.58335C14.9665 9.5223 15.0015 9.43777 15 9.34996C14.9993 9.2616 14.9647 9.17687 14.9033 9.11328C14.808 9.01711 14.6639 8.9882 14.5388 9.04015Z"
      fill="var(--primary-brand-color)"
    />
  </svg>
);

const InverterIcon = () => (
  <svg width="100" height="104" viewBox="0 0 100 104" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.6345 8.57397C10.8442 8.57397 8.57397 10.844 8.57397 13.6345C8.57397 16.4249 10.8442 18.6951 13.6345 18.6951C16.4249 18.6951 18.6951 16.4251 18.6951 13.6345C18.6953 10.844 16.4251 8.57397 13.6345 8.57397ZM13.6345 15.663C12.5161 15.663 11.6061 14.7532 11.6061 13.6345C11.6061 12.5159 12.5161 11.6061 13.6345 11.6061C14.753 11.6061 15.663 12.5159 15.663 13.6345C15.6632 14.753 14.7532 15.663 13.6345 15.663Z"
      fill="var(--primary-brand-color)"
    />
    <path
      d="M68.1393 8.57397C65.349 8.57397 63.0787 10.844 63.0787 13.6345C63.0787 16.4249 65.349 18.6951 68.1393 18.6951C70.9296 18.6951 73.1999 16.4251 73.1999 13.6345C73.1999 10.844 70.9296 8.57397 68.1393 8.57397ZM68.1393 15.663C67.0209 15.663 66.1108 14.7532 66.1108 13.6345C66.1108 12.5159 67.0209 11.6061 68.1393 11.6061C69.2577 11.6061 70.1678 12.5159 70.1678 13.6345C70.1678 14.753 69.2577 15.663 68.1393 15.663Z"
      fill="var(--primary-brand-color)"
    />
    <path
      d="M13.6345 94.9217C16.4249 94.9217 18.6951 92.6514 18.6951 89.8611C18.6951 87.0707 16.4249 84.8005 13.6345 84.8005C10.8442 84.8005 8.57397 87.0707 8.57397 89.8611C8.57397 92.6514 10.8442 94.9217 13.6345 94.9217ZM13.6345 87.8326C14.753 87.8326 15.663 88.7424 15.663 89.8611C15.663 90.9795 14.753 91.8896 13.6345 91.8896C12.5161 91.8896 11.6061 90.9795 11.6061 89.8611C11.6061 88.7424 12.5161 87.8326 13.6345 87.8326Z"
      fill="var(--primary-brand-color)"
    />
    <path
      d="M68.1393 84.8005C65.349 84.8005 63.0787 87.0707 63.0787 89.8611C63.0787 92.6514 65.349 94.9217 68.1393 94.9217C70.9296 94.9217 73.1999 92.6514 73.1999 89.8611C73.1999 87.0707 70.9296 84.8005 68.1393 84.8005ZM68.1393 91.8896C67.0209 91.8896 66.1108 90.9795 66.1108 89.8611C66.1108 88.7424 67.0209 87.8326 68.1393 87.8326C69.2577 87.8326 70.1678 88.7424 70.1678 89.8611C70.1678 90.9795 69.2577 91.8896 68.1393 91.8896Z"
      fill="var(--primary-brand-color)"
    />
    <path
      d="M55.5503 18.7099H26.2234C20.4004 18.7099 15.663 23.4464 15.663 29.2682V74.226C15.663 80.049 20.4004 84.7866 26.2234 84.7866H55.5503C61.3733 84.7866 66.1109 80.049 66.1109 74.226C66.1109 72.1083 66.1109 31.3859 66.1109 29.2682C66.1109 23.4464 61.3733 18.7099 55.5503 18.7099V18.7099ZM63.0788 74.226C63.0788 78.3771 59.7014 81.7545 55.5503 81.7545H26.2234C22.0723 81.7545 18.6951 78.3771 18.6951 74.226V41.3194H63.0788V74.226ZM63.0788 38.2873H18.6951V29.2684C18.6951 25.1183 22.0723 21.7422 26.2234 21.7422H55.5503C59.7014 21.7422 63.0788 25.1185 63.0788 29.2684V38.2873Z"
      fill="var(--primary-brand-color)"
    />
    <path
      d="M27.3981 27.4478C26.5608 27.4478 25.882 28.1265 25.882 28.9638V31.5558C25.882 32.3931 26.5608 33.0719 27.3981 33.0719C28.2353 33.0719 28.9141 32.3931 28.9141 31.5558V28.9638C28.9141 28.1265 28.2353 27.4478 27.3981 27.4478Z"
      fill="var(--primary-brand-color)"
    />
    <path
      d="M54.3758 27.4478C53.5385 27.4478 52.8597 28.1265 52.8597 28.9638V31.5558C52.8597 32.3931 53.5385 33.0719 54.3758 33.0719C55.2131 33.0719 55.8918 32.3931 55.8918 31.5558V28.9638C55.8918 28.1265 55.2131 27.4478 54.3758 27.4478Z"
      fill="var(--primary-brand-color)"
    />
    <path
      d="M45.4392 30.3357C44.8079 29.7855 43.8504 29.8514 43.3002 30.4827C42.6909 31.1817 41.8112 31.5827 40.887 31.5827C39.9626 31.5827 39.0829 31.1817 38.4737 30.4827C37.9236 29.8514 36.9659 29.7857 36.3346 30.3357C35.7033 30.8858 35.6376 31.8435 36.1877 32.4748C38.6744 35.3284 43.1019 35.3254 45.5862 32.4748C46.1362 31.8435 46.0705 30.8858 45.4392 30.3357V30.3357Z"
      fill="var(--primary-brand-color)"
    />
    <path
      d="M31.888 63.5411H35.875L30.8595 76.7416C30.1453 78.6983 32.6304 80.2032 34.0442 78.722L51.2613 61.0881C52.727 59.5862 51.6643 56.9913 49.5154 56.9913H46.7358L51.9386 48.6555C51.9447 48.6345 52.7185 47.492 52.0019 46.1999C51.5754 45.4311 50.7644 44.9535 49.8853 44.9535H39.2491C37.5218 44.9535 35.9896 45.9826 35.3357 47.5785C29.2905 60.9965 29.6644 60.1619 29.6408 60.2211C29.0059 61.8077 30.1738 63.5411 31.888 63.5411V63.5411ZM38.1375 48.7382C38.3205 48.2809 38.7569 47.9856 39.2493 47.9856H48.7826L43.3857 56.6323C42.4654 58.1069 43.528 60.0234 45.2666 60.0234H48.0634L35.6084 72.7801L39.1396 63.4861C39.6669 62.0412 38.5948 60.5088 37.0567 60.5088H32.8356C38.5699 47.7804 38.1123 48.8006 38.1375 48.7382V48.7382Z"
      fill="var(--primary-brand-color)"
    />
    <path
      d="M89.1689 70.003C92.0535 70.003 94.4003 67.6564 94.4003 64.7717C94.4003 61.8871 92.0535 59.5403 89.1689 59.5403C86.2844 59.5403 83.9376 61.8871 83.9376 64.7717C83.9376 67.6564 86.2844 70.003 89.1689 70.003ZM89.1689 62.5724C90.3816 62.5724 91.3682 63.559 91.3682 64.7717C91.3682 65.9845 90.3816 66.9709 89.1689 66.9709C87.9563 66.9709 86.9697 65.9845 86.9697 64.7717C86.9697 63.559 87.9563 62.5724 89.1689 62.5724Z"
      fill="var(--primary-brand-color)"
    />
    <path
      d="M12.9976 103.496H68.7763C75.9431 103.496 81.7739 97.6649 81.7739 90.498V75.6027H92.3795C96.5816 75.6027 100 72.1841 100 67.9823V61.5609C100 57.3588 96.5814 53.9404 92.3795 53.9404H91.7899V43.9044C91.7899 43.0671 91.1111 42.3883 90.2738 42.3883C89.4366 42.3883 88.7578 43.0671 88.7578 43.9044V53.9404H81.7737V30.4799H88.7578V37.8404C88.7578 38.6776 89.4366 39.3564 90.2738 39.3564C91.1111 39.3564 91.7899 38.6776 91.7899 37.8404V29.2508C92.2071 28.1441 93.5665 24.087 94.141 16.8682C94.4965 12.4005 90.9484 8.57417 86.4673 8.57417H80.9976C79.184 3.57848 74.3907 0 68.7763 0H12.9976C5.83072 0 0 5.83073 0 12.9974V62.2053C0 63.0426 0.678786 63.7214 1.51605 63.7214C2.35331 63.7214 3.0321 63.0426 3.0321 62.2053V12.9974C3.0321 7.50262 7.50262 3.0321 12.9976 3.0321H68.7763C73.4097 3.0321 77.3145 6.21054 78.425 10.5016C78.8719 12.2361 78.7416 90.498 78.7416 90.498C78.7416 95.993 74.271 100.464 68.7761 100.464H12.9976C7.50262 100.464 3.0321 95.993 3.0321 90.498V68.2695C3.0321 67.4322 2.35331 66.7535 1.51605 66.7535C0.678786 66.7535 0 67.4322 0 68.2695V90.498C0 97.6649 5.83072 103.496 12.9976 103.496V103.496ZM92.3797 56.9727C94.9099 56.9727 96.9681 59.0311 96.9681 61.5611V67.9825C96.9681 70.5126 94.9097 72.5708 92.3797 72.5708H81.7741V56.9727H92.3797ZM81.6997 11.6061H86.4675C89.1914 11.6061 91.3343 13.9194 91.1186 16.6274C90.6682 22.2867 89.7085 25.8767 89.2045 27.4476H81.7739C81.7674 12.51 81.8088 12.6481 81.6997 11.6061Z"
      fill="var(--primary-brand-color)"
    />
  </svg>
);

const DCAC = () => (
  <svg width="32" height="18" viewBox="0 0 32 18" fill="none" xmlns="https://www.w3.org/2000/svg">
    <line y1="5.06403" x2="2.94737" y2="5.06403" stroke="var(--primary-brand-color)" strokeWidth="2" />
    <line x1="3.6842" y1="5.06403" x2="6.63157" y2="5.06403" stroke="var(--primary-brand-color)" strokeWidth="2" />
    <line x1="7.36841" y1="5.06403" x2="10.3158" y2="5.06403" stroke="var(--primary-brand-color)" strokeWidth="2" />
    <line x1="11.0526" y1="5.06403" x2="14" y2="5.06403" stroke="var(--primary-brand-color)" strokeWidth="2" />
    <path d="M0 1.60803H14" stroke="var(--primary-brand-color)" strokeWidth="2" />
    <path d="M18.7596 15.6879C22.4937 10.9702 26.9846 19.5704 31.234 14.692" stroke="var(--primary-brand-color)" strokeWidth="2" />
    <path d="M18 11H32" stroke="var(--primary-brand-color)" strokeWidth="2" />
    <path d="M24 1L6 17" stroke="var(--primary-brand-color)" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

const TrackingAngle = () => (
  <svg width="43" height="34" viewBox="0 0 43 34" fill="none" xmlns="https://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1118_115)">
      <path
        d="M22.3776 14.2097L21.2845 11.1773L18.35 10.0477L19.6521 7.10479L18.35 4.1619L21.2845 3.03236L22.3776 0L25.2256 1.3455L28.0736 0L29.1667 3.03236L32.1013 4.1619L30.7992 7.10479L32.1013 10.0477L29.1667 11.1773L28.0736 14.2097L25.2256 12.8642L22.3776 14.2097ZM25.2256 11.3894L27.3444 12.3905L28.1575 10.1345L30.3408 9.29419L29.3721 7.10479L30.3408 4.91543L28.1575 4.0751L27.3444 1.81917L25.2256 2.82016L23.1068 1.81917L22.2936 4.0751L20.1105 4.91543L21.0792 7.10479L20.1105 9.29419L22.2936 10.1345L23.1068 12.3905L25.2256 11.3894ZM25.1638 10.0585C26.7766 10.0585 28.084 8.70752 28.084 7.04096C28.084 5.37441 26.7766 4.0234 25.1638 4.0234C23.551 4.0234 22.2436 5.37441 22.2436 7.04096C22.2436 8.70752 23.551 10.0585 25.1638 10.0585ZM25.1638 8.85149C24.1961 8.85149 23.4117 8.0409 23.4117 7.04096C23.4117 6.04103 24.1961 5.23042 25.1638 5.23042C26.1314 5.23042 26.9159 6.04103 26.9159 7.04096C26.9159 8.0409 26.1314 8.85149 25.1638 8.85149Z"
        fill="var(--primary-brand-color)"
      />
    </g>
    <path d="M13.6106 16.2234L28.0749 23.8484L38.8342 29.5912C39.7525 30.0813 39.4042 31.4734 38.3634 31.4734H2.3606" stroke="var(--primary-brand-color)" stroke-width="4" stroke-linecap="round" />
    <path d="M26.8606 23.9657C24.1106 24.6696 21.7751 27.731 22.3606 31.4734" stroke="var(--primary-brand-color)" stroke-width="4" stroke-linecap="round" />
    <defs>
      <clipPath id="clip0_1118_115">
        <rect width="14.2766" height="14.7525" fill="white" transform="translate(18.35)" />
      </clipPath>
    </defs>
  </svg>
);

const GCR = () => (
  <svg width="30" height="15" viewBox="0 0 30 15" fill="none" xmlns="https://www.w3.org/2000/svg">
    <path
      d="M8.20422 12.8755H3.20777C3.05804 12.8755 2.91495 12.9373 2.81232 13.0463C2.48604 13.3929 2.73177 13.9617 3.20777 13.9617H8.20422C8.66367 13.9617 8.91556 13.4268 8.62287 13.0726C8.51969 12.9478 8.36618 12.8755 8.20422 12.8755Z"
      fill="var(--primary-brand-color)"
    />
    <path
      d="M2.81232 13.0463L2.44826 12.7036L2.44826 12.7036L2.81232 13.0463ZM8.62287 13.0726L9.00828 12.7541L9.00828 12.7541L8.62287 13.0726ZM3.20777 13.3755H8.20422V12.3755H3.20777V13.3755ZM8.20422 13.4617H3.20777V14.4617H8.20422V13.4617ZM3.20777 13.4617C3.19173 13.4617 3.18616 13.4579 3.18382 13.4563C3.17936 13.4532 3.17288 13.4466 3.16819 13.4357C3.16349 13.4249 3.16311 13.4156 3.16392 13.4102C3.16434 13.4074 3.16538 13.4007 3.17638 13.3891L2.44826 12.7036C1.8216 13.3693 2.29355 14.4617 3.20777 14.4617V13.4617ZM8.23746 13.3912C8.24691 13.4026 8.24787 13.4092 8.24821 13.4125C8.24879 13.4181 8.24797 13.4269 8.24323 13.437C8.2385 13.447 8.23219 13.4533 8.22755 13.4564C8.22478 13.4582 8.21906 13.4617 8.20422 13.4617V14.4617C9.08664 14.4617 9.57042 13.4343 9.00828 12.7541L8.23746 13.3912ZM8.20422 13.3755C8.21708 13.3755 8.22927 13.3812 8.23746 13.3912L9.00828 12.7541C8.81012 12.5143 8.51529 12.3755 8.20422 12.3755V13.3755ZM3.20777 12.3755C2.92019 12.3755 2.64538 12.4942 2.44826 12.7036L3.17638 13.3891C3.18452 13.3804 3.19588 13.3755 3.20777 13.3755V12.3755Z"
      fill="var(--primary-brand-color)"
    />
    <path
      d="M1.48036 9.03915L6.66541 4.42181L9.30621 2.02341C9.50914 1.83911 9.50721 1.51584 9.30201 1.31814C9.11643 1.13934 8.82972 1.12799 8.64383 1.29207L0.76742 8.24479C0.528998 8.45525 0.545989 8.83676 0.803033 9.04441C1.00613 9.20849 1.29271 9.20626 1.48036 9.03915Z"
      fill="var(--primary-brand-color)"
      stroke="var(--primary-brand-color)"
    />
    <path d="M5.62073 12.3972V4.51468" stroke="var(--primary-brand-color)" strokeWidth="2" />
    <path
      d="M18.208 12.8755H13.2116C13.0618 12.8755 12.9187 12.9373 12.8161 13.0463C12.4898 13.3929 12.7355 13.9617 13.2116 13.9617H18.208C18.6675 13.9617 18.9193 13.4268 18.6267 13.0726C18.5235 12.9478 18.37 12.8755 18.208 12.8755Z"
      fill="var(--primary-brand-color)"
    />
    <path
      d="M12.8161 13.0463L12.452 12.7036L12.452 12.7036L12.8161 13.0463ZM18.6267 13.0726L19.0121 12.7541L19.0121 12.7541L18.6267 13.0726ZM13.2116 13.3755H18.208V12.3755H13.2116V13.3755ZM18.208 13.4617H13.2116V14.4617H18.208V13.4617ZM13.2116 13.4617C13.1955 13.4617 13.1899 13.4579 13.1876 13.4563C13.1831 13.4532 13.1767 13.4466 13.172 13.4357C13.1673 13.4249 13.1669 13.4156 13.1677 13.4102C13.1681 13.4074 13.1692 13.4007 13.1802 13.3891L12.452 12.7036C11.8254 13.3693 12.2973 14.4617 13.2116 14.4617V13.4617ZM18.2412 13.3912C18.2507 13.4026 18.2517 13.4092 18.252 13.4125C18.2526 13.4181 18.2518 13.4269 18.247 13.437C18.2423 13.447 18.236 13.4533 18.2313 13.4564C18.2286 13.4582 18.2228 13.4617 18.208 13.4617V14.4617C19.0904 14.4617 19.5742 13.4343 19.0121 12.7541L18.2412 13.3912ZM18.208 13.3755C18.2209 13.3755 18.2331 13.3812 18.2412 13.3912L19.0121 12.7541C18.8139 12.5143 18.5191 12.3755 18.208 12.3755V13.3755ZM13.2116 12.3755C12.924 12.3755 12.6492 12.4942 12.452 12.7036L13.1802 13.3891C13.1883 13.3804 13.1997 13.3755 13.2116 13.3755V12.3755Z"
      fill="var(--primary-brand-color)"
    />
    <path
      d="M11.4841 9.03915L16.6692 4.42181L19.31 2.02341C19.5129 1.83911 19.511 1.51584 19.3058 1.31814C19.1202 1.13934 18.8335 1.12799 18.6476 1.29207L10.7712 8.24479C10.5328 8.45525 10.5498 8.83676 10.8068 9.04441C11.0099 9.20849 11.2965 9.20626 11.4841 9.03915Z"
      fill="var(--primary-brand-color)"
      stroke="var(--primary-brand-color)"
    />
    <path d="M15.6245 12.3972V4.51468" stroke="var(--primary-brand-color)" strokeWidth="2" />
    <path
      d="M28.2118 12.8755H23.2153C23.0656 12.8755 22.9225 12.9373 22.8199 13.0463C22.4936 13.3929 22.7393 13.9617 23.2153 13.9617H28.2118C28.6712 13.9617 28.9231 13.4268 28.6304 13.0726C28.5273 12.9478 28.3738 12.8755 28.2118 12.8755Z"
      fill="var(--primary-brand-color)"
    />
    <path
      d="M22.8199 13.0463L22.4558 12.7036L22.4558 12.7036L22.8199 13.0463ZM28.6304 13.0726L29.0158 12.7541L29.0158 12.7541L28.6304 13.0726ZM23.2153 13.3755H28.2118V12.3755H23.2153V13.3755ZM28.2118 13.4617H23.2153V14.4617H28.2118V13.4617ZM23.2153 13.4617C23.1993 13.4617 23.1937 13.4579 23.1914 13.4563C23.1869 13.4532 23.1805 13.4466 23.1758 13.4357C23.1711 13.4249 23.1707 13.4156 23.1715 13.4102C23.1719 13.4074 23.1729 13.4007 23.1839 13.3891L22.4558 12.7036C21.8292 13.3693 22.3011 14.4617 23.2153 14.4617V13.4617ZM28.245 13.3912C28.2545 13.4026 28.2554 13.4092 28.2558 13.4125C28.2564 13.4181 28.2555 13.4269 28.2508 13.437C28.2461 13.447 28.2398 13.4533 28.2351 13.4564C28.2324 13.4582 28.2266 13.4617 28.2118 13.4617V14.4617C29.0942 14.4617 29.578 13.4343 29.0158 12.7541L28.245 13.3912ZM28.2118 13.3755C28.2247 13.3755 28.2368 13.3812 28.245 13.3912L29.0158 12.7541C28.8177 12.5143 28.5229 12.3755 28.2118 12.3755V13.3755ZM23.2153 12.3755C22.9278 12.3755 22.6529 12.4942 22.4558 12.7036L23.1839 13.3891C23.1921 13.3804 23.2035 13.3755 23.2153 13.3755V12.3755Z"
      fill="var(--primary-brand-color)"
    />
    <path
      d="M21.4881 9.03915L26.6731 4.42181L29.3139 2.02341C29.5168 1.83911 29.5149 1.51584 29.3097 1.31814C29.1241 1.13934 28.8374 1.12799 28.6515 1.29207L20.7751 8.24479C20.5367 8.45525 20.5537 8.83676 20.8107 9.04441C21.0138 9.20849 21.3004 9.20626 21.4881 9.03915Z"
      fill="var(--primary-brand-color)"
      stroke="var(--primary-brand-color)"
    />
    <path d="M25.6284 12.3972V4.51468" stroke="var(--primary-brand-color)" strokeWidth="2" />
  </svg>
);

const DCIcon = () => (
  <svg width="20" height="9" viewBox="0 0 20 9" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 6.93726H4.21052" stroke="var(--primary-brand-color)" stroke-width="2" />
    <path d="M5.26318 6.93726H9.47371" stroke="var(--primary-brand-color)" stroke-width="2" />
    <path d="M10.5262 6.93726H14.7368" stroke="var(--primary-brand-color)" stroke-width="2" />
    <path d="M15.7894 6.93726H20" stroke="var(--primary-brand-color)" stroke-width="2" />
    <path d="M0 2H20" stroke="var(--primary-brand-color)" stroke-width="2" />
  </svg>
);

const ACIcon = () => (
  <svg width="22" height="11" viewBox="0 0 22 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.08521 8.69706C7.41963 1.95749 13.8352 14.2435 19.9058 7.27435" stroke="var(--primary-brand-color)" stroke-width="2" />
    <path d="M1 2H21" stroke="var(--primary-brand-color)" stroke-width="2" />
  </svg>
);

const Generation = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="https://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.63843 12.5523H7.78842V17.4198L14.6584 8.83218H11.5084V3.9646L4.63843 12.5523ZM9.0283 11.3124H7.21829L10.2683 7.49979V10.0724H12.0783L9.0283 13.8849V11.3124Z"
      fill="var(--primary-brand-color)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.0004 4.99992H4.19359C5.55402 3.07865 7.60679 1.99997 10.0003 1.99997C14.4185 1.99997 18.0001 5.58163 18.0001 9.99984H20C20 4.47708 15.523 0 10.0003 0C7.1962 0 4.72562 1.18249 3.00057 3.2703V0H1.00063V6.99989H8.0004V4.99992ZM11.9996 15.0001H15.8064C14.446 16.9214 12.3932 18 9.99967 18C5.58154 18 1.99993 14.4184 1.99993 10.0002H0C0 15.5229 4.47701 20 9.99967 20C12.8038 20 15.2744 18.8175 16.9994 16.7297V20H18.9994V13.0001H11.9996V15.0001Z"
      fill="var(--primary-brand-color)"
    />
  </svg>
);

const Ruler = () => (
  <svg width="22" height="12" viewBox="0 0 22 12" fill="none" xmlns="https://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22 10V2C22 0.89543 21.1046 0 20 0H2C0.89543 0 0 0.89543 0 2V10C0 11.1046 0.89543 12 2 12H20C21.1046 12 22 11.1046 22 10ZM2 2H4V5H6V2H8V7H10V2H12V5H14V2H16V7H18V2H20V10H2V2Z"
      fill="var(--primary-brand-color)"
    />
  </svg>
);

const Compass = () => (
  <svg width="27" height="17" viewBox="0 0 27 17" fill="none" xmlns="https://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.6169 1.7871C21.0516 1.4464 21.1278 0.817841 20.7871 0.383162C20.4464 -0.0515172 19.8179 -0.127707 19.3832 0.212987L0.883178 14.713C0.547484 14.9761 0.41562 15.4232 0.554794 15.8263C0.693967 16.2295 1.07354 16.5 1.50006 16.5H25.5001C26.0523 16.5 26.5001 16.0523 26.5001 15.5C26.5001 14.9478 26.0523 14.5 25.5001 14.5H13.8269C13.6032 12.439 12.8899 10.4631 11.7497 8.73713L20.6169 1.7871ZM12.8205 14.5H4.39698L10.9598 9.35621C11.9667 10.903 12.6044 12.6634 12.8205 14.5Z"
      fill="var(--primary-brand-color)"
    />
  </svg>
);

const InfoBoxes = ({ reportData }) => {
  // console.log("reportData", reportData);
  return (
    <InfoBoxWrap>
      <div className="info-box-title">
        <h3>Report Rundown</h3>
      </div>
      <div className="info-box-container">
        {/* <div className="info_box">
          <Bulb />
          <p>Module Rating</p>
          <p>{`${reportData.mod_rating} W`}</p>
        </div> */}
        <div className="info_box">
          <GCR />
          <p>GCR</p>
          <p>{`${+reportData.gcr.toFixed(2)}`}</p>
        </div>
        <div className="info_box">
          <Pound />
          <p>Module Quantity</p>
          <p>{` ${reportData.en_mod_target === 1 ? parseInt(reportData.mod_target) : parseInt(reportData.module_count)}`}</p>
        </div>

        {reportData.do_finance == 0 ? (
          <div className="info_box">
            <Pound />
            <p>{`Inverter Quantity`}</p>
            <p>{`${reportData.inverter_qty}`}</p>
          </div>
        ) : reportData.toggle_finance_type == 1 ? (
          <div className="info_box">
            <DollarCircleOutlined style={{ fontSize: 20, color: "var(--primary-brand-color)" }} />
            <p>{`LCOE`}</p>
            <p>{`${reportData.lcoe.toFixed(2)} $/MWh`}</p>
          </div>
        ) : (
          <div className="info_box">
            <DollarCircleOutlined style={{ fontSize: 20, color: "var(--primary-brand-color)" }} />
            <p>{`IRR`}</p>
            <p>{`${reportData.irr * 100} %`}</p>
          </div>
        )}

        {/* <div className="info_box">
          <Beam />
          <p>Racking Product</p>
          <p>{`${cleanRackingName(reportData.racking_name)}`}</p>
        </div> */}
        {reportData.track_mode === 1 ? (
          <div className="info_box">
            <Compass />
            <p>{`Tracking Angle`}</p>
            <p>{`+/- ${reportData.rlim}°`}</p>
          </div>
        ) : (
          <div className="info_box">
            <Compass />
            <p>{`Tilt Angle`}</p>
            <p>{`${reportData.tilt}°`}</p>
          </div>
        )}
        <div className="info_box">
          <LightningBolt />
          <p>Yield</p>
          <p>{`${+reportData["y. Yield (kWh/kWp)"]?.toFixed(2)} kWh/kWp`}</p>
        </div>
        <div className="info_box">
          <Generation />
          <p>Generation Yr 1</p>
          <p>{`${+reportData["fh. Energy injected into Grid (MWh)"].toFixed(2)} MWh`}</p>
        </div>
        {reportData.platform == "internal_sift" ? (
          <div className="info_box">
            <Ruler />
            <p>Pitch</p>
            <p>{`${parseFloat(reportData.pitch).toFixed(2)}`}</p>
          </div>
        ) : (
          <div className="info_box">
            <DCAC />
            <p>DC:AC</p>
            <p> {`${parseFloat(reportData.dcac.toFixed(2))}`}</p>
          </div>
        )}
        {/* <div className="info_box">
          <Sunshine />
          <p>Site Capacity</p>
          <p> {`${parseFloat(reportData.capacity / 1000).toFixed(2)} MWp`}</p>
        </div> */}
        <div className="info_box">
          <DCIcon />
          <p>DC Capacity</p>
          <p> {`${reportData.MWp} MWp`}</p>
        </div>
        <div className="info_box">
          <ACIcon />
          <p>AC Capacity</p>
          <p> {`${reportData.MWac} MWac`}</p>
        </div>
      </div>
    </InfoBoxWrap>
  );
};

export { InfoBoxes };
